module.exports = __webpack_public_path__ + "img/footer_card_2.614f00c3.jpg";